import { inject } from "@angular/core";
import { UrlTree, Router, ActivatedRouteSnapshot } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { PiaContextService } from "../../shared/pia-api/pia-context.service";

export async function defaultYearProductInfoRedirect(
  redirectData: Pick<ActivatedRouteSnapshot, "url">,
): Promise<UrlTree> {
  const contextService = inject(PiaContextService);
  const router = inject(Router);

  const countryID = redirectData.url[1].path;
  const languageID = redirectData.url[2].path;

  if (!languageID || !countryID) {
    return router.createUrlTree(["pia", countryID, "not-found"]);
  }

  const latestYear = await firstValueFrom(
    contextService.getLatestYearByCountryIdAndLanguageId({
      countryID,
      languageID,
    }),
  );
  return router.createUrlTree([
    "pia",
    countryID,
    languageID,
    latestYear,
    "product-info",
  ]);
}
